// document.addEventListener("DOMContentLoaded", function () {
//     if(window.wizzyConfig.common.isOnProductViewPage)
//     {
//         wizzyLazyAssets.load();
//     }
// });

// Boosting Collection Pages Sort Order Code Starts
var realPage = 1;
var lastProductId = null;
var boostingDone = false;
var wizzyCollectionProductIds2 = [];
var wizzyCachedFilters = null;
var receivedProductIds = [];
const WIZZY_REAL_PAGE_KEY = "wizzy_realPage";
const WIZZY_LAST_PRODUCT_ID = "wizzy_lastProductId";
const WIZZY_COLLECTION_HANDLE = "wizzy_collectionHandle";
const WIZZY_RECEIVED_PRODUCT_IDS = "wizzy_receivedProductIds";
// Boosting Collection Pages Sort Order Code Ends

window.onWizzyScriptLoaded = function () {
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
        // console.log("before_init");
        window.wizzyConfig.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
            {
                dom: "#search_input",
                type: "search"
            }
        ]
        
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "main"
        ]

        return data;
    });
    // Boosting Collection Pages Sort Order Code Starts
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
         if (window.wizzyConfig.common.isOnCategoryPage) {
            data.filters.boostGroupIds = [];
            data.filters.productsCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;

            if (
               data.filters.sort &&
               data.filters.sort.length &&
               data.filters.sort[0].field == "relevance" &&
               window.wizzyConfig.common.isOnCategoryPage === true &&
               typeof window.inStockWizzyCollectionProductIds !== 'undefined'
            ) {
               var hasAttributes = data.filters.attributes && Object.values(data.filters.attributes).some(v => Array.isArray(v) && v.length > 0);
               var hasFloatAttributes = data.filters.floatAttributes && Object.values(data.filters.floatAttributes).some(v => Array.isArray(v) && v.length > 0);
               var hasBrands = data.filters.brands && data.filters.brands.length > 0;
               var hasSellingPrice = data.filters.sellingPrice && data.filters.sellingPrice.length > 0;
               var hasGenders = data.filters.genders && data.filters.genders.length > 0;
               data.filters.productsCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;
               var hasAnyOtherFilterApplied = hasAttributes || hasBrands || hasSellingPrice || hasGenders || hasFloatAttributes;
               var productsCount = data.filters?.productsCount ?? 50;
               var currentPage = realPage ?? 1;
               var totalPages = window.wizzyConfig?.pageStore?.searchedResponse?.pages;
               var filtersChanged = hasFilterStateChanged(data.filters);
               wizzyCachedFilters = {
                  attributes: deepClone(data.filters.attributes || {}),
                  floatAttributes: deepClone(data.filters.floatAttributes || {}),
                  brands: deepClone(data.filters.brands || []),
                  sellingPrice: deepClone(data.filters.sellingPrice || []),
                  genders: deepClone(data.filters.genders || []),
               };
               setCachedFilters(wizzyCachedFilters);
               if (currentPage === 100) {
                  data.filters.page = currentPage;
               }
               if (filtersChanged) {
                  realPage = 1;
                  setSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
                  setSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
                  setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, []);
               }
               const currentCollectionHandle =
                  data.filters?.categories?.[0] ||
                  window.wizzyConfig?.common?.collectionHandle ||
                  null;
               if (!hasAnyOtherFilterApplied && realPage < 101 && (typeof totalPages === 'undefined' || totalPages > 1) && !boostingDone) {
                  var wizzyCollectionProductIds1 = window.inStockWizzyCollectionProductIds.slice(0, 50);
                  if (typeof window.inStockWizzyCollectionProductIdsNew != "undefined" && window.inStockWizzyCollectionProductIdsNew) {
                     wizzyCollectionProductIds1 = window.inStockWizzyCollectionProductIdsNew.slice(0, 50);
                  }
                  data.filters.boostGroupIds = wizzyCollectionProductIds1;
                  const cachedCollectionKey = getSessionString(WIZZY_COLLECTION_HANDLE);
                  if (cachedCollectionKey !== currentCollectionHandle) {
                     setSessionString(WIZZY_COLLECTION_HANDLE, currentCollectionHandle);
                     setSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
                     setSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
                     setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, []);
                  }
               } else if (hasAnyOtherFilterApplied) {
                  data.filters.boostGroupIds = [];
               }
               if (typeof window.inStockWizzyCollectionProductIdsNew != "undefined" && window.inStockWizzyCollectionProductIdsNew && !hasAnyOtherFilterApplied && realPage < 101 && realPage > 1 && (typeof totalPages === 'undefined' || totalPages > 1) && !boostingDone) {
                  if (data.filters && data.filters.type === "CATEGORY_PAGE" && data.filters.sort && data.filters.sort.length > 0 && data.filters.sort[0].field === "relevance" && window.inStockWizzyCollectionProductIdsNew && window.inStockWizzyCollectionProductIdsNew.length > 0) {
                     if (realPage === totalPages + 1) {
                        data.filters.page = totalPages + 1;
                     }
                     wizzyCollectionProductIds2 = window.inStockWizzyCollectionProductIdsNew.slice(0, 2000);
                     var start = 0;

                     if (typeof lastProductId !== "undefined" && lastProductId) {
                        var lastIndex = wizzyCollectionProductIds2.indexOf(lastProductId);
                        if (lastProductId === wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                           boostingDone = true;
                        } else if (lastProductId != wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                           boostingDone = false;
                        }

                        if (lastIndex !== -1) {
                           start = lastIndex + 1;
                        }
                     } else {
                        start = (currentPage - 1) * productsCount;
                     }
                     var end = (2 * productsCount) + start;
                     var wizzyCollectionBoostedProductIds = wizzyCollectionProductIds2.slice(start, end);
                     const remainingIds = window.inStockWizzyCollectionProductIdsNew.length - end;
                     var categoriesHandle = data.filters?.categories?.[0] || window.wizzyConfig?.common?.collectionHandle;
                     if (
                        categoriesHandle &&
                        remainingIds <= 50 &&
                        window.wizzyLazy &&
                        !window.wizzyLazy.loading &&
                        !boostingDone &&
                        window.wizzyLazy.nextPageToLoad <= window.wizzyLazy.totalPages
                     ) {
                        loadNextInStockBatchIfNeeded(
                           categoriesHandle,
                           50
                        );
                     }
                     if (wizzyCollectionBoostedProductIds.length > 50) {
                        wizzyCollectionBoostedProductIds = wizzyCollectionBoostedProductIds.slice(0, 50);
                     }
                     if (wizzyCollectionBoostedProductIds.length === 0) {
                        boostingDone = true;
                     }
                     if (wizzyCollectionBoostedProductIds.length > 0) {
                        realPage++;
                        data.filters.boostGroupIds = wizzyCollectionBoostedProductIds;
                        if (totalPages) {
                           if (realPage !== totalPages + 2) {
                              data.filters.page = 1;
                           }
                        }
                        if (wizzyCollectionBoostedProductIds.length < productsCount) {
                           data.filters.productsCount = wizzyCollectionBoostedProductIds.length;
                        }
                     }
                  } else {
                     realPage++;
                  }
               } else {
                  if (realPage === 1 && !hasAnyOtherFilterApplied) {
                     var wizzyCollectionProductIds1 = window.inStockWizzyCollectionProductIds.slice(0, 50);
                     if (typeof window.inStockWizzyCollectionProductIdsNew != "undefined" && window.inStockWizzyCollectionProductIdsNew) {
                        wizzyCollectionProductIds1 = window.inStockWizzyCollectionProductIdsNew.slice(0, 50);
                     }
                     data.filters.boostGroupIds = wizzyCollectionProductIds1;
                     const cachedCollectionKey = getSessionString(WIZZY_COLLECTION_HANDLE);
                     if (cachedCollectionKey !== currentCollectionHandle) {
                        setSessionString(WIZZY_COLLECTION_HANDLE, currentCollectionHandle);
                        setSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
                        setSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
                        setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, []);
                     }
                  }
                  data.filters.page = realPage;
                  realPage++;
               }
               setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
            }
         }

         if (data.filters.type === "AUTOCOMPLETE_DEFAULT") {
            delete data.filters.boostGroupIds;
            data.filters.page = 1;
         }

         return data;
    }, 3
    );
    // Boosting Collection Pages Sort Order Code Ends
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
        // console.log("before_init");
        window.wizzyConfig.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
            {
                dom: "#search_input",
                type: "search"
            }
        ]
        
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "main"
        ]

        return data;
    });

    const colorMap = new Map([["Rust", ["#b7410e", !1]], ["Multi", ["https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png", !0]], ["Peach", ["#ffdab9", !1]], ["Golden", ["#ffd900", !1]], ["Off-White", ["#f5f5f5", !1]], ["Cream", ["#fffdd0", !1]], ["Sky Blue", ["#87CEEB", !1]], ["Navy Blue", ["#000080", !1]], ["Light Blue", ["#ADD8E6", !1]], ["Olive Green", ["#556B2F", !1]], ["Light Green", ["#90EE90", !1]], ["Dark Grey", ["#A9A9A9", !1]], ["Dark Blue", ["#00008B", !1]], ["Jet Black", ["#000000", !1]], ["Bright White", ["#FFFFFF", !1]], ["Light Grey", ["#D3D3D3", !1]], ["Wine", ["#722F37", !1]], ["Teal Blue", ["#008080", !1]], ["Royal Blue", ["#4169E1", !1]], ["Indigo Blue", ["#4B0082", !1]], ["Mid Blue", ["#0000CD", !1]], ["Peacock Blue", ["#006994", !1]], ["Deep Blue", ["#000080", !1]], ["Aqua Blue", ["#00FFFF", !1]], ["Ice Blue", ["#BCE6E6", !1]], ["Night Blue", ["#191970", !1]], ["Denim Blue", ["#1560BD", !1]], ["Turquoise Blue", ["#40E0D0", !1]], ["Brick Red", ["#B22222", !1]], ["Light Red", ["#FF6961", !1]], ["Dark Red", ["#8B0000", !1]], ["Bright Red", ["#FF0000", !1]], ["Carrot red", ["#FF4500", !1]], ["Burn Red", ["#9A3334", !1]], ["Cardinal Red", ["#C41E3A", !1]], ["Oxblood Red", ["#800020", !1]], ["Rio Red", ["#DA2C43", !1]], ["Rose Red", ["#FF033E", !1]], ["Rumba Red", ["#C76E70", !1]], ["Spice Red", ["#A23C3C", !1]], ["Tango Red", ["#E25822", !1]], ["Deep Red", ["#8B0000", !1]], ["Mustard Yellow", ["#FFDB58", !1]], ["Light Yellow", ["#FFFFE0", !1]], ["Lemon Yellow", ["#FFF44F", !1]], ["Mellow Yellow", ["#F8DE7E", !1]], ["Bright Yellow", ["#FFFF00", !1]], ["Golden Yellow", ["#FFD700", !1]], ["Chrome Yellow", ["#FFA700", !1]], ["Corn Yellow", ["#FBEC5D", !1]], ["Musturd Yellow", ["#FFDB58", !1]], ["Pale Yellow", ["#EEE8AA", !1]], ["Pastel Yellow", ["#FDFD96", !1]], ["Taffy Yellow", ["#F8DE7E", !1]], ["Dark Green", ["#006400", !1]], ["Light Pink", ["#FFB6C1", !1]], ["Onion Pink", ["#F5B9F5", !1]], ["Island Pink", ["#FFD1DC", !1]], ["Lilac Pink", ["#FFC0CB", !1]], ["Rose Pink", ["#FF66CC", !1]], ["Coral Pink", ["#FF7F50", !1]], ["Dusty Pink", ["#D8BFD8", !1]], ["Send Pink", ["#FF91A4", !1]], ["Blossom Pink", ["#FFC3A0", !1]], ["Delicacy Pink", ["#FEC3AC", !1]], ["Flamingo Pink", ["#FC8EAC", !1]], ["Pastel Pink", ["#FFD1BB", !1]], ["Baby Pink", ["#FFC0CB", !1]], ["Pastel Purple", ["#B39EB5", !1]], ["Dark Purple", ["#800080", !1]], ["Beige", ["#F5F5DC", !1]], ["Light Purple", ["#E6E6FA", !1]], ["Cloud Cream", ["#FFF8E7", !1]], ["Custard Cream", ["#FFF0C1", !1]], ["Dark Cream", ["#EEE8AA", !1]], ["Dawn Cream", ["#FFFAF0", !1]], ["Fawn Cream", ["#E5AA70", !1]], ["Italian Cream", ["#F6ECD8", !1]], ["Light Orange", ["#FFD68F", !1]], ["Apricot Orange", ["#FDD5B1", !1]], ["Bright Orange", ["#FF8C00", !1]], ["Burnt Orange", ["#FF4500", !1]], ["Coral Orange", ["#FF7F50", !1]], ["Golden Orange", ["#FFD700", !1]], ["Apricot Orange", ["#FBCEB1", !1]], ["Dark Olive", ["#556B2F", !1]], ["Olive Brown", ["#806517", !1]], ["Light Olive", ["#AAB300", !1]], ["Olive Grey", ["#B5B35C", !1]], ["Branch Olive", ["#5F6527", !1]], ["Dark Olive Green", ["#556B2F", !1]], ["Deep Olive Green", ["#556B2F", !1]], ["Dusty Olive", ["#8A8662", !1]], ["Olive Melange", ["#6B6C4A", !1]], ["Dark Maroon", ["#800000", !1]], ["Maroon gold", ["#B03060", !1]], ["Silver Grey", ["#C0C0C0", !1]], ["Lime Green", ["#00FF00", !1]], ["State Gray", ["#808080", !1]], ["Teal Green", ["#008080", !1]], ["Dusty Teal", ["#4e5d4e", !1]], ["Teal Black", ["#003838", !1]], ["Teal Grey", ["#69838d", !1]], ["Midnight Navy", ["#000080", !1]], ["Grey Melange", ["#808080", !1]], ["Charcoal Grey", ["#36454F", !1]], ["Ercus Melange", ["#B5B5B5", !1]], ["Air Force Blue", ["#5D8AA8", !1]], ["Aquamarine Blue", ["#7FFFD4", !1]], ["Carrot Brown", ["#ED9121", !1]], ["Colonial Blue", ["#002F6C", !1]], ["Cornet Blue", ["#6495ED", !1]], ["Deep Wine", ["#8B0000", !1]], ["Bottle Green", ["#092E20", !1]]])
    function findHaxCode(key) {
        return colorMap.has(key) ? colorMap.get(key) : [key, !1];
    }
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log("before render results 1");
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        // console.log(facets);
        if(facets)
        {
          // console.log("inside facets condition");
          facets.forEach((facet) => {
            if(facet.key === "colors")
            {
              // console.log("inside colors");
              facet.data.forEach((item) => {
                // console.log("inside loop");
                // console.log(item.key);
                let color = findHaxCode(item.key) || ["#e5e5e5", !1];
                // console.log(color);
                // console.log("inside loop 1");
                (item.isSwatch = !0),
                  (item.isURLSwatch = color[1]),
                  (item.isVisualSwatch = !0),
                  (item.swatchValue = color[0]),
                  (item.data = {
                    value: item.key,
                    swatch: {
                      type: "visual",
                      value: color[0],
                    },
                  });
              });
            }
          });
        }
        // console.log(payload);
      }
    //   console.log("before render results 2");
      console.log("Before render");
      return payload;
    }
  );

   // Boosting Collection Pages Sort Order Code Starts
   try {
      window.wizzyConfig.events.registerEvent(
         window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
         function (payload) {
            var tempPage = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.page;
            var tempRealPage;

            if (tempPage &&
               realPage > 1 &&
               payload.response?.payload?.filters?.sort &&
               payload.response.payload.filters.sort.length &&
               payload.response.payload.filters.sort[0].field == "relevance" &&
               window.wizzyConfig.common.isOnCategoryPage === true) {
               tempRealPage = realPage - 1;
               payload.response.payload.filters.page = tempRealPage;
               payload.response.payload.filters.productsCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;

               var results = payload.response?.payload?.result;

               if (results && results.length > 0) {
                  var lastProduct = results.at(-1);
                  var lastId = lastProduct?.groupId || lastProduct?.id || null;
                  if (lastId) lastProductId = parseInt(lastId);
                  if (lastProductId) {
                     if (lastProductId === wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                        boostingDone = true;
                     } else if (lastProductId != wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                        boostingDone = false;
                     }
                     setSessionNumber(WIZZY_LAST_PRODUCT_ID, lastProductId);
                  }
               }
            }

            if (payload.response?.payload?.filters?.sort &&
               payload.response.payload.filters.sort.length &&
               payload.response.payload.filters.sort[0].field == "relevance" &&
               window.wizzyConfig.common.isOnCategoryPage === true) {
               var results = payload.response?.payload?.result;
               var hasAttributes = payload.response.payload.filters.attributes && Object.values(payload.response.payload.filters.attributes).some(v => Array.isArray(v) && v.length > 0);
               var hasFloatAttributes = payload.response.payload.filters.floatAttributes && Object.values(payload.response.payload.filters.floatAttributes).some(v => Array.isArray(v) && v.length > 0);
               var hasBrands = payload.response.payload.filters.brands && payload.response.payload.filters.brands.length > 0;
               var hasSellingPrice = payload.response.payload.filters.sellingPrice && payload.response.payload.filters.sellingPrice.length > 0;
               var hasGenders = payload.response.payload.filters.genders && payload.response.payload.filters.genders.length > 0;
               var hasAnyOtherFilterApplied = hasAttributes || hasBrands || hasSellingPrice || hasGenders || hasFloatAttributes;
               if (results && results.length > 0 && !hasAnyOtherFilterApplied) {
                  var pCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;
                  var tPCount = payload.response?.payload?.total ?? 0;
                  var tPages = Math.ceil(tPCount / pCount);
                  if (tempRealPage === tPages) {
                     for (var i = results.length - 1; i >= 0; i--) {
                        var product = results[i];
                        var id = product?.groupId || product?.id || null;

                        if (!id) break;

                        var strId = String(id);

                        if (receivedProductIds.includes(strId)) {
                           results.splice(i, 1);
                        } else {
                           break;
                        }
                     }
                  }

                  results.forEach(function (product) {
                     var id = product?.groupId || product?.id || null;
                     if (id) {
                        receivedProductIds.push(String(id));
                     }
                  });
               } else {
                  receivedProductIds = [];
               }
               setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, receivedProductIds);
            } else {
               receivedProductIds = [];
               setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, receivedProductIds);
            }

            return payload;
         }
      );
   } catch (e) {
      console.log("wizzy before render", e);
   }
   // Boosting Collection Pages Sort Order Code Ends

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
        console.log("BEFORE_SEARCH");
        // const sellingPriceExists = data.sort.some(
        // (s) => s.field === "product_wizzy-best-selling_sortOrder:float" && s.order === "asc"
        // );

        // if (!sellingPriceExists && data.sort[0].field === "relevance") {
        // data.sort.push({field: "product_wizzy-best-selling_sortOrder:float", order: "asc"});
            
        // // data.sort = [{ field: "sellingPrice", order: "asc", isForParent: !1}];
        // }
        let cancel_btn = document.querySelector('.search--cancel');
        if(cancel_btn)
        {
            cancel_btn.click();
        }

        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
        products.forEach((product) => {
            // if(product.sellingPrice == "1,290.00")
            // {
            //     product.price = 1500;
            //     product.discountPercentage = 1;
            // }
            product.sellingPrice = product.sellingPrice?.replace(/\.00$/, '');
            product.price = product.price?.replace(/\.00$/, '');
            let attributes = product.attributes;
            if(attributes)
            {
                attributes.forEach((attr) => {
                    if(attr.id === "product_variant_prices")
                    {
                        let values = attr.values;
                        const seen = {};
                        let allDifferent = true;
                        let minPrice;
                        if(values.length > 1)
                        {
                            minPrice = values[0].value[0];
                        }
                        else
                        {
                            allDifferent = false;
                        }
                        values.forEach((val) => {
                            let price = val.value[0];
                            if (price < minPrice) {
                                minPrice = price;
                            }
                            if (seen[price]) {
                                allDifferent = false;
                            } else {
                                seen[price] = true;
                            }
                        });
                        if(allDifferent)
                        {
                            product.diffrentPrices = true;
                            product.minPrice = minPrice;
                        }
                    }
                })
            }
        })

        return products;
    });
    function changeGrid(columns)
    {
        const el = document.querySelector('.wizzy-search-results');
        if(window.innerWidth >= 768)
        {
            
            if (el) {
                el.setAttribute('data-columns', columns);
            }
        }
        else
        {
            if (el) {
                el.setAttribute('data-mobile-columns', columns);
            }
        }
    }
    function updateFacetSelectedValues() {
        // STEP 1 — Read selected filters
        const selectedItems = document.querySelectorAll(".wizzy-selected-facet-list li");
        const selectedMap = {};

        selectedItems.forEach(li => {
            const key = li.getAttribute("data-facetkey");
            const value = li.getAttribute("title")?.trim(); // value stored in title

            if (!key || !value) return;

            if (!selectedMap[key]) {
                selectedMap[key] = [];
            }
            selectedMap[key].push(value);
        });

        // STEP 2 — Update each facet block
        document.querySelectorAll(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block").forEach(block => {
            const facetKey = block.getAttribute("data-key");
            if (!facetKey) return;

            // Create UI placeholder if missing
            let displayDiv = block.querySelector(".facet-selected-values");
            if (!displayDiv) {
                displayDiv = document.createElement("div");
                displayDiv.className = "facet-selected-values";

                const head = block.querySelector(".wizzy-facet-head");
                const body = block.querySelector(".wizzy-facet-body");

                if (head && body) head.insertAdjacentElement("afterend", displayDiv);
            }

            let values = selectedMap[facetKey];

            // SPECIAL CASE — sellingPrice
            if (facetKey === "sellingPrice" && (!values || values.length === 0)) {
                
                // Find slider inside this block
                const slider = block.querySelector(".wizzy-facet-range-slider");

                if (slider) {
                    const min = slider.getAttribute("data-min");
                    const max = slider.getAttribute("data-max");

                    if (min && max) {
                        displayDiv.innerText = `₹${min} - ₹${max}`;
                    } else {
                        displayDiv.innerText = "All";
                    }
                } else {
                    displayDiv.innerText = "All";
                }

                return; // done for price facet
            }

            // NORMAL FACETS
            if (values && values.length > 0) {
                displayDiv.innerText = values.join(", ");
            } else {
                displayDiv.innerText = "All";
            }
        });
    }

    function initWizzyQuickProductTypeFilters() {
        const summaryWrapper = document.querySelector('.wizzy-search-summary-wrapper');
        if (!summaryWrapper) return;

        const oldWrapper = document.querySelector('.wizzy-quick-filters-wrapper');
        oldWrapper && oldWrapper.remove();

        const facetBlock = document.querySelector(
            ".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block[data-key='product_product_type']"
        );
        if (!facetBlock) return;

        const facetItems = facetBlock.querySelectorAll(
            '.wizzy-facet-list .facet-item-label-value'
        );
        if (!facetItems || facetItems.length <= 1) return;

        const selectedItems = document.querySelectorAll('.wizzy-selected-facet-list li');
        const selectedMap = {};

        selectedItems.forEach(li => {
            const key = li.getAttribute('data-facetkey');
            const value = li.getAttribute('title')?.trim();
            if (!key || !value) return;

            if (!selectedMap[key]) selectedMap[key] = [];
            selectedMap[key].push(value);
        });

        const selectedProductTypes = selectedMap['product_product_type'] || [];

        const quickWrapper = document.createElement('div');
        quickWrapper.className = 'wizzy-quick-filters-wrapper';

        facetItems.forEach((facetItem) => {
            const label = facetItem.textContent.trim();
            if (!label) return;

            const quickItem = document.createElement('div');
            quickItem.className = 'wizzy-quick-filter-item';
            quickItem.textContent = label;

            if (selectedProductTypes.includes(label)) {
            quickItem.classList.add('selected');
            }

            quickItem.addEventListener('click', () => {
            quickWrapper
                .querySelectorAll('.wizzy-quick-filter-item')
                .forEach(el => el.classList.remove('selected'));

            quickItem.classList.add('selected');
            facetItem.click();
            });

            quickWrapper.appendChild(quickItem);
        });

        summaryWrapper.insertAdjacentElement('afterend', quickWrapper);
    }






    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
        updateFacetSelectedValues();
        initWizzyQuickProductTypeFilters();
        let apply_btn = document.querySelector('.wizzy-apply-all-button-block');
        if(apply_btn)
        {
            apply_btn.addEventListener('click', function(){
                let close_btn = document.querySelector('.wizzy-filters-close-btn');
                if(close_btn)
                {
                    close_btn.click();
                }
            })
        }
        // console.log("view_render");
        let grids;
        if(window.innerWidth >= 768)
        {
            let two_grid = document.querySelector('.wz-two-grid');
            let four_grid = document.querySelector('.wz-four-grid');
            let six_grid = document.querySelector('.wz-six-grid');
            grids = localStorage.getItem('wz-grids') || 4;
            if(grids == 6)
            {
                six_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                four_grid.classList.remove('selected');
            }
            else if(grids == 4){
                four_grid.classList.add('selected');
                six_grid.classList.remove('selected');
                two_grid.classList.remove('selected');
            }
            else
            {
                two_grid.classList.add('selected');
                four_grid.classList.remove('selected');
                six_grid.classList.remove('selected');
            }
            changeGrid(grids);
            if(two_grid && four_grid && six_grid)
            {
                // console.log("inside grids");
                two_grid.addEventListener('click', function(){
                    two_grid.classList.add('selected');
                    four_grid.classList.remove('selected');
                    six_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 2);
                    changeGrid(2);
                });
                four_grid.addEventListener('click', function(){
                    four_grid.classList.add('selected');
                    six_grid.classList.remove('selected');
                    two_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 4);
                    changeGrid(4);
                });
                six_grid.addEventListener('click', function(){
                    six_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    four_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 6);
                    changeGrid(6);
                });
            }
        }
        else
        {
            let one_grid = document.querySelector('.wz-one-grid');
            let two_grid = document.querySelector('.for-mobile .wz-two-grid');
            let three_grid = document.querySelector('.wz-three-grid');
            grids = localStorage.getItem('wz-mobile-grid') || 2;
            if(grids == 1)
            {
                one_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                three_grid.classList.remove('selected');
            }
            else if(grids == 2)
            {
                two_grid.classList.add('selected');
                three_grid.classList.remove('selected');
                one_grid.classList.remove('selected');
            }
            else if(grids == 3)
            {
                three_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                one_grid.classList.remove('selected');
            }
            changeGrid(grids);
            if(one_grid && two_grid && three_grid)
            {
                one_grid.addEventListener('click', function(){
                    one_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    three_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 1);
                    changeGrid(1);
                });
                two_grid.addEventListener('click', function(){
                    two_grid.classList.add('selected');
                    three_grid.classList.remove('selected');
                    one_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 2);
                    changeGrid(2);
                });
                three_grid.addEventListener('click', function(){
                    three_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    one_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 3);
                    changeGrid(3);
                });
            }
        }
        // if(window.innerWidth >= 768)
        // {
        //     let two_grid = document.querySelector('.wz-two-grid');
        //     let four_grid = document.querySelector('.wz-four-grid');
        //     let six_grid = document.querySelector('.wz-six-grid');
            
        // }
        // else
        // {
        //     let one_grid = document.querySelector('.wz-one-grid');
        //     let two_grid = document.querySelector('.wz-two-grid');
        //     let three_grid = document.querySelector('.wz-six-grid');
            
        // }


        console.log("view render");

      // Boosting Collection Pages Sort Order Code Starts
      if (window.wizzyConfig.common.isOnCategoryPage === true) {
         var clearallbtn = document.querySelector('.wizzy-filters-clear-all');
         if (clearallbtn) {
            clearallbtn.addEventListener('click', function () {
               realPage = 1;
               setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
            });
         }

         var clearallbtnTop = document.querySelector('.wizzy-search-filters-top .wizzy-filters-clear-all');
         if (clearallbtnTop) {
            clearallbtnTop.addEventListener('click', function () {
               realPage = 1;
               setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
            });
         }

         var filterItems = document.querySelectorAll('.wizzy-facet-list-item');
         if (filterItems.length > 0) {
            filterItems.forEach((filterItem) => {
               filterItem.addEventListener('click', function () {
                  realPage = 1;
                  setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
               });
            });
         }

         var sortItems = document.querySelectorAll('.wizzy-common-select-option');
         if (sortItems.length > 0) {
            sortItems.forEach((sortItem) => {
               sortItem.addEventListener('click', function () {
                  realPage = 1;
                  setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
               });
            });
         }
      }
      // Boosting Collection Pages Sort Order Code Ends

        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
        updateFacetSelectedValues();
        initWizzyQuickProductTypeFilters();
        let apply_btn = document.querySelector('.wizzy-apply-all-button-block');
        if(apply_btn)
        {
            apply_btn.addEventListener('click', function(){
                let close_btn = document.querySelector('.wizzy-filters-close-btn');
                if(close_btn)
                {
                    close_btn.click();
                }
            })
        }
        // console.log("view_render");
        let grids;
        if(window.innerWidth >= 768)
        {
            let two_grid = document.querySelector('.wz-two-grid');
            let four_grid = document.querySelector('.wz-four-grid');
            let six_grid = document.querySelector('.wz-six-grid');
            grids = localStorage.getItem('wz-grids') || 4;
            if(grids == 6)
            {
                six_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                four_grid.classList.remove('selected');
            }
            else if(grids == 4){
                four_grid.classList.add('selected');
                six_grid.classList.remove('selected');
                two_grid.classList.remove('selected');
            }
            else
            {
                two_grid.classList.add('selected');
                four_grid.classList.remove('selected');
                six_grid.classList.remove('selected');
            }
            changeGrid(grids);
            if(two_grid && four_grid && six_grid)
            {
                // console.log("inside grids");
                two_grid.addEventListener('click', function(){
                    two_grid.classList.add('selected');
                    four_grid.classList.remove('selected');
                    six_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 2);
                    changeGrid(2);
                });
                four_grid.addEventListener('click', function(){
                    four_grid.classList.add('selected');
                    six_grid.classList.remove('selected');
                    two_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 4);
                    changeGrid(4);
                });
                six_grid.addEventListener('click', function(){
                    six_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    four_grid.classList.remove('selected');
                    localStorage.setItem('wz-grids', 6);
                    changeGrid(6);
                });
            }
        }
        else
        {
            let one_grid = document.querySelector('.wz-one-grid');
            let two_grid = document.querySelector('.for-mobile .wz-two-grid');
            let three_grid = document.querySelector('.wz-three-grid');
            grids = localStorage.getItem('wz-mobile-grid') || 2;
            if(grids == 1)
            {
                one_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                three_grid.classList.remove('selected');
            }
            else if(grids == 2)
            {
                two_grid.classList.add('selected');
                three_grid.classList.remove('selected');
                one_grid.classList.remove('selected');
            }
            else if(grids == 3)
            {
                three_grid.classList.add('selected');
                two_grid.classList.remove('selected');
                one_grid.classList.remove('selected');
            }
            changeGrid(grids);
            if(one_grid && two_grid && three_grid)
            {
                one_grid.addEventListener('click', function(){
                    one_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    three_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 1);
                    changeGrid(1);
                });
                two_grid.addEventListener('click', function(){
                    two_grid.classList.add('selected');
                    three_grid.classList.remove('selected');
                    one_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 2);
                    changeGrid(2);
                });
                three_grid.addEventListener('click', function(){
                    three_grid.classList.add('selected');
                    two_grid.classList.remove('selected');
                    one_grid.classList.remove('selected');
                    localStorage.setItem('wz-mobile-grid', 3);
                    changeGrid(3);
                });
            }
        }
        // if(window.innerWidth >= 768)
        // {
        //     let two_grid = document.querySelector('.wz-two-grid');
        //     let four_grid = document.querySelector('.wz-four-grid');
        //     let six_grid = document.querySelector('.wz-six-grid');
            
        // }
        // else
        // {
        //     let one_grid = document.querySelector('.wz-one-grid');
        //     let two_grid = document.querySelector('.wz-two-grid');
        //     let three_grid = document.querySelector('.wz-six-grid');
            
        // }


        console.log("products cache");

      // Boosting Collection Pages Sort Order Code Starts
      if (window.wizzyConfig.common.isOnCategoryPage === true) {
         realPage = getSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
         lastProductId = getSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
         wizzyCachedFilters = getCachedFilters();
         receivedProductIds = getSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS);
      }
      // Boosting Collection Pages Sort Order Code Ends

        return data;
    });
}

// Boosting Collection Pages Sort Order Code Starts
document.body.addEventListener("click", function (event) {
  if (event.target.closest(".wizzy-selected-facet-list-item")) {
    if (realPage !== 1) {
      realPage = 1;
      setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
    }
  }

  if (event.target.closest(".wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-header .wizzy-filters-clear-all")) {
    if (realPage !== 1) {
      realPage = 1;
      setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
    }
  }
});

async function loadNextInStockBatchIfNeeded(collectionHandle, threshold = 50) {
  if (
    !Array.isArray(window.inStockWizzyCollectionProductIdsNew) ||
    !window.wizzyLazy ||
    window.wizzyLazy.loading ||
    window.wizzyLazy.nextPageToLoad > window.wizzyLazy.totalPages
  ) {
    return;
  }

  window.wizzyLazy.loading = true;

  try {
    const page = window.wizzyLazy.nextPageToLoad;

    const res = await fetch(
      `/collections/${collectionHandle}?page=${page}&section_id=wizzy-collection-batch`
    );

    if (!res.ok) throw new Error("Section fetch failed");

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const script = doc.querySelector("script[data-wizzy-batch]");
    if (!script) throw new Error("wizzy batch script not found");

    const data = JSON.parse(script.textContent);

    if (Array.isArray(data.inStockIds) && data.inStockIds.length > 0) {
      window.inStockWizzyCollectionProductIdsNew.push(...data.inStockIds);
      window.wizzyLazy.nextPageToLoad += 1;
    }
  } catch (err) {
    console.error("Wizzy lazy batch load failed:", err);
  } finally {
    window.wizzyLazy.loading = false;
  }
}

function areStringArraysEqual(a = [], b = []) {
  if (a.length !== b.length) return false;

  const setA = new Set(a);
  for (const val of b) {
    if (!setA.has(val)) return false;
  }
  return true;
}

function arePriceRangesEqual(a = [], b = []) {
  if (a.length !== b.length) return false;

  const normalize = arr =>
    arr
      .map(r => `${r.gte ?? ''}-${r.lte ?? ''}`)
      .sort();

  const na = normalize(a);
  const nb = normalize(b);

  return na.every((v, i) => v === nb[i]);
}

function areAttributesEqual(a = {}, b = {}) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!Array.isArray(b[key])) return false;

    const arrA = a[key];
    const arrB = b[key];

    if (arrA.length !== arrB.length) return false;

    const setA = new Set(arrA);
    for (const val of arrB) {
      if (!setA.has(val)) return false;
    }
  }

  return true;
}

function normalizeRange(range) {
  return JSON.stringify({
    gte: Number(range.gte),
    lte: Number(range.lte)
  });
}

function areRangeArraysEqual(arrA = [], arrB = []) {
  if (arrA.length !== arrB.length) return false;

  const normA = arrA.map(normalizeRange).sort();
  const normB = arrB.map(normalizeRange).sort();

  for (let i = 0; i < normA.length; i++) {
    if (normA[i] !== normB[i]) return false;
  }

  return true;
}

function areFloatAttributesEqual(a = {}, b = {}) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!Array.isArray(b[key])) return false;

    if (!areRangeArraysEqual(a[key], b[key])) return false;
  }

  return true;
}

function hasFilterStateChanged(currentFilters) {
  if (!wizzyCachedFilters) return true;

  if (!areAttributesEqual(
    currentFilters.attributes || {},
    wizzyCachedFilters.attributes
  )) return true;

  if (!areFloatAttributesEqual(
    currentFilters.floatAttributes || {},
    wizzyCachedFilters.floatAttributes
  )) return true;

  if (!areStringArraysEqual(
    currentFilters.brands || [],
    wizzyCachedFilters.brands
  )) return true;

  if (!arePriceRangesEqual(
    currentFilters.sellingPrice || [],
    wizzyCachedFilters.sellingPrice
  )) return true;

  if (!areStringArraysEqual(
    currentFilters.genders || [],
    wizzyCachedFilters.genders
  )) return true;

  return false;
}

function deepClone(obj) {
  if (typeof structuredClone === "function") {
    return structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}

function getSessionNumber(key, defaultValue = 0) {
  const val = sessionStorage.getItem(key);
  return val !== null ? Number(val) : defaultValue;
}

function setSessionNumber(key, value) {
  sessionStorage.setItem(key, String(value));
}

function getSessionString(key, defaultValue = null) {
  const val = sessionStorage.getItem(key);
  return val !== null ? val : defaultValue;
}

function setSessionString(key, value) {
  if (value === null || value === undefined) {
    sessionStorage.removeItem(key);
  } else {
    sessionStorage.setItem(key, String(value));
  }
}

function setCachedFilters(filters) {
  sessionStorage.setItem(
    "wizzyCachedFilters",
    JSON.stringify(filters)
  );
}

function getCachedFilters() {
  try {
    return JSON.parse(
      sessionStorage.getItem("wizzyCachedFilters")
    ) || null;
  } catch {
    return null;
  }
}

function getSessionStringArray(key, defaultValue = []) {
  try {
    const val = sessionStorage.getItem(key);
    return val ? JSON.parse(val) : defaultValue;
  } catch {
    return defaultValue;
  }
}

function setSessionStringArray(key, array) {
  try {
    if (!Array.isArray(array)) return;
    sessionStorage.setItem(key, JSON.stringify(array));
  } catch {
    // silently ignore
  }
}
// Boosting Collection Pages Sort Order Code Ends
